import ValidationPoSielAdTransdev from "./ot/transdev/po_siel_ad";
import ValidationPoSielSescoTransdev from "./ot/transdev/po_siel_sesco";
import ValidationPriseServiceCoquilleTransdev from "./ot/transdev/prise_service_coquille";
import ReportingTetraSaeTransdev from "./ot/transdev/reporting_tetra_sae";
import CoquilleConfigDspTransdev from "./ot/transdev/coquille_config_dsp";
import TetraTransdev from "./ot/transdev/tetra";

// TRANSDEV
import TetraBusTransdev from "./ot/transdev/tetra_bus";
import ValidationPoSielTransdev from "./ot/transdev/po_siel";
import ValidationGeolocalisationTransdev from "./ot/transdev/geolocalisation";
import ValidationPriseServiceTransdev from "./ot/transdev/prise_service";
import DeclarationsPbTransdev from "./ot/transdev/declarations_pb_transdev";
import PierreTransdev from "./pierre/pierretransdev";
import { BrowserRouter as Router, Routes, Route, Link, Outlet } from "react-router-dom";


// ALL
import TetraBusAll from "./ot/all/tetra_bus";
import ValidationPriseServiceAll from "./ot/all/prise_service";
import ValidationPriseServiceCoquilleAll from "./ot/all/prise_service_coquille";
import ValidationPoSielSescoAll from "./ot/all/po_siel_sesco";
import ValidationPoSielAdAll from "./ot/all/po_siel_ad";
import ValidationGeolocalisationAll from "./ot/all/geolocalisation";
import ValidationTetraAll from "./ot/all/tetra";
import ValidationPoSielAll from "./ot/all/po_siel";
import ValidationCoquilleConfigDspAll from "./ot/all/coquille_config_dsp";
import ReportingTetraSaeAll from "./ot/all/reporting_tetra_sae";

// CAP
import TetraBusCap from "./ot/cap/tetra_bus";
import ValidationPriseServiceCap from "./ot/cap/prise_service";
import ValidationPriseServiceCoquilleCap from "./ot/cap/prise_service_coquille";
import ValidationPoSielSescoCap from "./ot/cap/po_siel_sesco";
import ValidationPoSielAdCap from "./ot/cap/po_siel_ad";
import ValidationGeolocalisationCap from "./ot/cap/geolocalisation";
import ValidationTetraCap from "./ot/cap/tetra";
import ValidationPoSielCap from "./ot/cap/po_siel";
import ValidationCoquilleConfigDspCap from "./ot/cap/coquille_config_dsp";
import ReportingTetraSaeCap from "./ot/cap/reporting_tetra_sae";

// ATM JOUR
import TetraBusAtmJour from "./ot/atm_jour/tetra_bus";
import ValidationPriseServiceAtmJour from "./ot/atm_jour/prise_service";
import ValidationPriseServiceCoquilleAtmJour from "./ot/atm_jour/prise_service_coquille";
import ValidationPoSielSescoAtmJour from "./ot/atm_jour/po_siel_sesco";
import ValidationPoSielAdAtmJour from "./ot/atm_jour/po_siel_ad";
import ValidationGeolocalisationAtmJour from "./ot/atm_jour/geolocalisation";
import ValidationTetraAtmJour from "./ot/atm_jour/tetra";
import ValidationPoSielAtmJour from "./ot/atm_jour/po_siel";
import ValidationCoquilleConfigDspAtmJour from "./ot/atm_jour/coquille_config_dsp";
import ReportingTetraSaeAtmJour from "./ot/atm_jour/reporting_tetra_sae";

// ATM NOC
import TetraBusAtmNoc from "./ot/atm_noc/tetra_bus";
import ValidationPriseServiceAtmNoc from "./ot/atm_noc/prise_service";
import ValidationPriseServiceCoquilleAtmNoc from "./ot/atm_noc/prise_service_coquille";
import ValidationPoSielSescoAtmNoc from "./ot/atm_noc/po_siel_sesco";
import ValidationPoSielAdAtmNoc from "./ot/atm_noc/po_siel_ad";
import ValidationGeolocalisationAtmNoc from "./ot/atm_noc/geolocalisation";
import ValidationTetraAtmNoc from "./ot/atm_noc/tetra";
import ValidationPoSielAtmNoc from "./ot/atm_noc/po_siel";
import ValidationCoquilleConfigDspAtmNoc from "./ot/atm_noc/coquille_config_dsp";
import ReportingTetraSaeAtmNoc from "./ot/atm_noc/reporting_tetra_sae";

// CAP NOC
import TetraBusCapNoc from "./ot/cap_noc/tetra_bus";
import ValidationPriseServiceCapNoc from "./ot/cap_noc/prise_service";
import ValidationPriseServiceCoquilleCapNoc from "./ot/cap_noc/prise_service_coquille";
import ValidationPoSielSescoCapNoc from "./ot/cap_noc/po_siel_sesco";
import ValidationPoSielAdCapNoc from "./ot/cap_noc/po_siel_ad";
import ValidationGeolocalisationCapNoc from "./ot/cap_noc/geolocalisation";
import ValidationTetraCapNoc from "./ot/cap_noc/tetra";
import ValidationPoSielCapNoc from "./ot/cap_noc/po_siel";
import ValidationCoquilleConfigDspCapNoc from "./ot/cap_noc/coquille_config_dsp";
import ReportingTetraSaeCapNoc from "./ot/cap_noc/reporting_tetra_sae";

// KEOLIS
import TetraBusKeolis from "./ot/keolis/tetra_bus";
import ValidationPriseServiceKeolis from "./ot/keolis/prise_service";
import ValidationPriseServiceCoquilleKeolis from "./ot/keolis/prise_service_coquille";
import ValidationPoSielSescoKeolis from "./ot/keolis/po_siel_sesco";
import ValidationPoSielAdKeolis from "./ot/keolis/po_siel_ad";
import ValidationGeolocalisationKeolis from "./ot/keolis/geolocalisation";
import ValidationTetraKeolis from "./ot/keolis/tetra";
import ValidationPoSielKeolis from "./ot/keolis/po_siel";
import ValidationCoquilleConfigDspKeolis from "./ot/keolis/coquille_config_dsp";
import ReportingTetraSaeKeolis from "./ot/keolis/reporting_tetra_sae";

// KEOLIS NOC
import TetraBusKeolisNoc from "./ot/keolis_noc/tetra_bus";
import ValidationPriseServiceKeolisNoc from "./ot/keolis_noc/prise_service";
import ValidationPriseServiceCoquilleKeolisNoc from "./ot/keolis_noc/prise_service_coquille";
import ValidationPoSielSescoKeolisNoc from "./ot/keolis_noc/po_siel_sesco";
import ValidationPoSielAdKeolisNoc from "./ot/keolis_noc/po_siel_ad";
import ValidationGeolocalisationKeolisNoc from "./ot/keolis_noc/geolocalisation";
import ValidationTetraKeolisNoc from "./ot/keolis_noc/tetra";
import ValidationPoSielKeolisNoc from "./ot/keolis_noc/po_siel";
import ValidationCoquilleConfigDspKeolisNoc from "./ot/keolis_noc/coquille_config_dsp";
import ReportingTetraSaeKeolisNoc from "./ot/keolis_noc/reporting_tetra_sae";

// CDS
import TetraBusCds from "./ot/cds/tetra_bus";
import ValidationPriseServiceCds from "./ot/cds/prise_service";
import ValidationPriseServiceCoquilleCds from "./ot/cds/prise_service_coquille";
import ValidationPoSielSescoCds from "./ot/cds/po_siel_sesco";
import ValidationPoSielAdCds from "./ot/cds/po_siel_ad";
import ValidationGeolocalisationCds from "./ot/cds/geolocalisation";
import ValidationTetraCds from "./ot/cds/tetra";
import ValidationPoSielCds from "./ot/cds/po_siel";
import ValidationCoquilleConfigDspCds from "./ot/cds/coquille_config_dsp";

import PierreCap from "./pierre/pierrecap";
import PierreCapNoc from "./pierre/pierrecapnoc";
import PierreKeolis from "./pierre/pierrekeolis";
import PierreKeolisNoc from "./pierre/pierrekeolisnoc";
import PierreAtmJour from "./pierre/pierreatmjour";
import PierreAtmNoc from "./pierre/pierreatmnoc";
import PierreCds from "./pierre/pierrecds";
import HomePage from "./pierre/main_page";
import VersionFooter from "./components/version_footer";

import Home from "./home";



import Login from "./components/login";
import AuthGuard from "./components/auth_guard";
import UserHeader from "./components/user_header";

const AppShell = () => {
  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", display: "flex", flexDirection: "column" }}>
      <AuthGuard />
      <UserHeader />
      <div style={{ paddingTop: "90px", flex: 1 }}>
        <Outlet />
      </div>
      <VersionFooter />
    </div>
  );
};


function Main() {
  return (
    <Router>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<AppShell />}>
          <Route path="/a87f2430f2" element={<Home />} />

          // ALL
          <Route path="/all/tetra_bus" element={<TetraBusAll />} />
          <Route path="/all/po_siel" element={<ValidationPoSielAll />} />
          <Route path="/all/prise_service" element={<ValidationPriseServiceAll />} />
          <Route path="/all/po_siel_sesco" element={<ValidationPoSielSescoAll />} />
          <Route path="/all/po_siel_ad" element={<ValidationPoSielAdAll />} />
          <Route path="/all/prise_service_coquille" element={<ValidationPriseServiceCoquilleAll />} />
          <Route path="/all/geolocalisation" element={<ValidationGeolocalisationAll />} />
          <Route path="/all/tetra" element={<ValidationTetraAll />} />
          <Route path="/all/coquille_config_dsp" element={<ValidationCoquilleConfigDspAll />} />
          <Route path="/all/reporting_tetra_sae" element={<ReportingTetraSaeAll />} />

          // CAP 
          <Route path="/cap/tetra_bus" element={<TetraBusCap />} />
          <Route path="/cap/po_siel" element={<ValidationPoSielCap />} />
          <Route path="/cap/prise_service" element={<ValidationPriseServiceCap />} />
          <Route path="/cap/po_siel_sesco" element={<ValidationPoSielSescoCap />} />
          <Route path="/cap/po_siel_ad" element={<ValidationPoSielAdCap />} />
          <Route path="/cap/prise_service_coquille" element={<ValidationPriseServiceCoquilleCap />} />
          <Route path="/cap/geolocalisation" element={<ValidationGeolocalisationCap />} />
          <Route path="/cap/tetra" element={<ValidationTetraCap />} />
          <Route path="/cap/coquille_config_dsp" element={<ValidationCoquilleConfigDspCap />} />
          <Route path="/cap/reporting_tetra_sae" element={<ReportingTetraSaeCap />} />

          // ATM JOUR
          <Route path="/atm_jour/tetra_bus" element={<TetraBusAtmJour />} />
          <Route path="/atm_jour/po_siel" element={<ValidationPoSielAtmJour />} />
          <Route path="/atm_jour/prise_service" element={<ValidationPriseServiceAtmJour />} />
          <Route path="/atm_jour/po_siel_sesco" element={<ValidationPoSielSescoAtmJour />} />
          <Route path="/atm_jour/po_siel_ad" element={<ValidationPoSielAdAtmJour />} />
          <Route path="/atm_jour/prise_service_coquille" element={<ValidationPriseServiceCoquilleAtmJour />} />
          <Route path="/atm_jour/geolocalisation" element={<ValidationGeolocalisationAtmJour />} />
          <Route path="/atm_jour/tetra" element={<ValidationTetraAtmJour />} />
          <Route path="/atm_jour/coquille_config_dsp" element={<ValidationCoquilleConfigDspAtmJour />} />
          <Route path="/atm_jour/reporting_tetra_sae" element={<ReportingTetraSaeAtmJour />} />
          <Route path="/atm_jour/declarations_pb_atm_jour" element={<PierreAtmJour />} />

          // ATM NOC
          <Route path="/atm_noc/tetra_bus" element={<TetraBusAtmNoc />} />
          <Route path="/atm_noc/po_siel" element={<ValidationPoSielAtmNoc />} />
          <Route path="/atm_noc/prise_service" element={<ValidationPriseServiceAtmNoc />} />
          <Route path="/atm_noc/po_siel_sesco" element={<ValidationPoSielSescoAtmNoc />} />
          <Route path="/atm_noc/po_siel_ad" element={<ValidationPoSielAdAtmNoc />} />
          <Route path="/atm_noc/prise_service_coquille" element={<ValidationPriseServiceCoquilleAtmNoc />} />
          <Route path="/atm_noc/geolocalisation" element={<ValidationGeolocalisationAtmNoc />} />
          <Route path="/atm_noc/tetra" element={<ValidationTetraAtmNoc />} />
          <Route path="/atm_noc/coquille_config_dsp" element={<ValidationCoquilleConfigDspAtmNoc />} />
          <Route path="/atm_noc/reporting_tetra_sae" element={<ReportingTetraSaeAtmNoc />} />

          // CAP NOC
          <Route path="/cap_noc/tetra_bus" element={<TetraBusCapNoc />} />
          <Route path="/cap_noc/po_siel" element={<ValidationPoSielCapNoc />} />
          <Route path="/cap_noc/prise_service" element={<ValidationPriseServiceCapNoc />} />
          <Route path="/cap_noc/po_siel_sesco" element={<ValidationPoSielSescoCapNoc />} />
          <Route path="/cap_noc/po_siel_ad" element={<ValidationPoSielAdCapNoc />} />
          <Route path="/cap_noc/prise_service_coquille" element={<ValidationPriseServiceCoquilleCapNoc />} />
          <Route path="/cap_noc/geolocalisation" element={<ValidationGeolocalisationCapNoc />} />
          <Route path="/cap_noc/tetra" element={<ValidationTetraCapNoc />} />
          <Route path="/cap_noc/coquille_config_dsp" element={<ValidationCoquilleConfigDspCapNoc />} />
          <Route path="/cap_noc/reporting_tetra_sae" element={<ReportingTetraSaeCapNoc />} />

          // KEOLIS
          <Route path="/keolis/tetra_bus" element={<TetraBusKeolis />} />
          <Route path="/keolis/po_siel" element={<ValidationPoSielKeolis />} />
          <Route path="/keolis/prise_service" element={<ValidationPriseServiceKeolis />} />
          <Route path="/keolis/po_siel_sesco" element={<ValidationPoSielSescoKeolis />} />
          <Route path="/keolis/po_siel_ad" element={<ValidationPoSielAdKeolis />} />
          <Route path="/keolis/prise_service_coquille" element={<ValidationPriseServiceCoquilleKeolis />} />
          <Route path="/keolis/geolocalisation" element={<ValidationGeolocalisationKeolis />} />
          <Route path="/keolis/tetra" element={<ValidationTetraKeolis />} />
          <Route path="/keolis/coquille_config_dsp" element={<ValidationCoquilleConfigDspKeolis />} />
          <Route path="/keolis/reporting_tetra_sae" element={<ReportingTetraSaeKeolis />} />

          // KEOLIS NOC
          <Route path="/keolis_noc/tetra_bus" element={<TetraBusKeolisNoc />} />
          <Route path="/keolis_noc/po_siel" element={<ValidationPoSielKeolisNoc />} />
          <Route path="/keolis_noc/prise_service" element={<ValidationPriseServiceKeolisNoc />} />
          <Route path="/keolis_noc/po_siel_sesco" element={<ValidationPoSielSescoKeolisNoc />} />
          <Route path="/keolis_noc/po_siel_ad" element={<ValidationPoSielAdKeolisNoc />} />
          <Route path="/keolis_noc/prise_service_coquille" element={<ValidationPriseServiceCoquilleKeolisNoc />} />
          <Route path="/keolis_noc/geolocalisation" element={<ValidationGeolocalisationKeolisNoc />} />
          <Route path="/keolis_noc/tetra" element={<ValidationTetraKeolisNoc />} />
          <Route path="/keolis_noc/coquille_config_dsp" element={<ValidationCoquilleConfigDspKeolisNoc />} />
          <Route path="/keolis_noc/reporting_tetra_sae" element={<ReportingTetraSaeKeolisNoc />} />

          // CDS

          <Route path="/cds1/po_siel" element={<ValidationPoSielCds />} />
          <Route path="/cds1/prise_service" element={<ValidationPriseServiceCds/>} />
          <Route path="/cds1/po_siel_sesco" element={<ValidationPoSielSescoCds />} />
          <Route path="/cds1/po_siel_ad" element={<ValidationPoSielAdCds />} />
          <Route path="/cds1/prise_service_coquille" element={<ValidationPriseServiceCoquilleCds />} />
          <Route path="/cds1/geolocalisation" element={<ValidationGeolocalisationCds />} />
          <Route path="/cds1/tetra" element={<ValidationTetraCds />} />
          <Route path="/cds1/coquille_config_dsp" element={<ValidationCoquilleConfigDspAll />} />

          <Route path="/declarations_pb" element={<HomePage />} />
          <Route path="/cap/declarations_pb_cap" element={<PierreCap />} />
          <Route path="/keolis/declarations_pb_keolis" element={<PierreKeolis />} />
          <Route path="/f2409746c1a8/declarations_pb_keolis" element={<PierreKeolis />} />
          <Route path="/cap_noc/declarations_pb_cap_noc" element={<PierreCapNoc />} />
          <Route path="/keolis_noc/declarations_pb_keolis_noc" element={<PierreKeolisNoc />} />
          <Route path="/atm_noc/declarations_pb_atm_noc" element={<PierreAtmNoc />} />
          <Route path="/all/declarations_pb" element={<PierreCds />} /></Route>

          // TRANSDEV
          <Route path="/transdev/tetra_bus" element={<TetraBusTransdev />} />
          <Route path="/transdev/po_siel" element={<ValidationPoSielTransdev />} />
          <Route path="/transdev/geolocalisation" element={<ValidationGeolocalisationTransdev />} />
          <Route path="/transdev/prise_service" element={<ValidationPriseServiceTransdev />} />
          <Route path="/transdev/coquille_config_dsp" element={<CoquilleConfigDspTransdev />} />
          <Route path="/transdev/reporting_tetra_sae" element={<ReportingTetraSaeTransdev />} />
          <Route path="/transdev/declarations_pb_transdev" element={<PierreTransdev />} />

      </Routes>
    </Router>
  );
}

export default Main;
